import { Link } from 'react-router-dom';

import DownloadAgreement from './DownloadAgreement';
import Tooltip from '../../../shared/Tooltip';
import { formatCurrency } from '../../../../lib/utils/formatters';
import {
  reformatDate,
} from '../../../../lib/utils/datetime_formatters';

const getStatus = (status) => {
  switch (status.toLowerCase()) {
    case 'paid':
    case 'void':
    case 'new':
    case 'pending':
      return status;
    case 'active':
    case 'funded':
      return 'Active';
    default:
      break;
  }
};

export const TableColumns = [
  {
    Header: 'Date',
    accessor: 'product.capture_date',
    Cell: ({ row: { original } }) =>
      reformatDate(
        original.product.disbursement_date
          ? original.product.disbursement_date
          : original.product.capture_date,
      ),
  },
  {
    Header: 'Order Key',
    accessor: 'order_key',
    Cell: ({ value }) => {
      return (
        <Link
          className="text-primary-blue font-avenir-medium cursor-pointer"
          to={`/orders/${value}`}
        >
          {value}
        </Link>
      );
    },
  },
  {
    Header: 'Term',
    accessor: 'product.installments',
    Cell: ({ value }) => {
      return value === 4 ? value * 2 + 'w' : value * 30 + 'd';
    },
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ value }) => (
      <Tooltip
        tooltip_text="Principal loan amount not including interest & fees"
        trigger_class="cursor-pointer"
        container_class="text-center p-4 px-6 text-sm bg-light-blue"
      >
        {formatCurrency(value)}
      </Tooltip>
    ),
  },
  {
    Header: 'Status',
    accessor: 'product.status',
    Cell: ({ row: { original } }) => (
      <span className="capitalize">
        {original.product.status
          ? getStatus(original.product.status)
          : getStatus(original.product.payment_plan_status)}
      </span>
    ),
  },
  {
    Header: 'Agreement',
    accessor: 'id',
    Cell: ({ row: { original } }) => (
      <DownloadAgreement
        buttonClass="flex cursor-pointer hover:text-primary-blue"
        buttonText="Download"
        order={original}
      />
    ),
  },
];
